import React from 'react';
import {
    Table,
    Row,
    Spin,
    Col,
    Button,
    Popover,
    Popconfirm, Form, Input, Select, InputNumber, Modal
} from 'antd';
const { TextArea } = Input;
import { asyncGet, reStart, actions ,addCheckData,addCommandDb} from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import {formatFormData, formItemLayout} from "./utils";
const FormItem = Form.Item;

class MachineCheck extends React.Component {
    handleCancel = () => {
        //请求接口下发命令
        this.props.addCommandDb();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
               values['creatTime']=moment().format('YYYY-MM-DD HH:mm:ss');
                await this.props.addCheckData(formatFormData(values));
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.modalShow();
            }
        });
    };
    render() {
        const { isModalShow, item ,uiStatus,} = this.props;
        const {isLoading,isUpdateShow} = uiStatus;
        const { getFieldDecorator } = this.props.form;
        const { pDieMobile, batteryStatus,blackScreen } = this.props;
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="室内温度">
                            {getFieldDecorator('indoorTemp', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入室内温度',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="室内湿度">
                            {getFieldDecorator('indoorHumidity', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入室内湿度',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="电池是否有鼓包">
                            {getFieldDecorator('batteryStatus', {
                                initialValue: '否',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入电池是否有鼓包',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择" onChange={(value) => this.props.changepBatteryStatus(value)}>
                                    <Option value="1">是</Option>

                                    <Option value="0">否</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>
                    {batteryStatus === '1' ? (
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="电池鼓包处理过程">
                                {getFieldDecorator('batteryStatusText', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入电池鼓包处理过程',
                                        },
                                    ],
                                })(
                                    <TextArea rows={4} placeholder="输入电池鼓包处理过程" style={{ width: '100%' }} />,
                                )}
                            </FormItem>
                        </Col>
                    ) : ''}



                    <Col span={24}>
                        <FormItem {...formItemLayout} label="假死手机数量" >
                            {getFieldDecorator('pDieMobile', {
                                initialValue: 0,
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入假死手机数量',
                                    },
                                ],
                            })(
                                <InputNumber onChange={(value) => this.props.changepDieMobile(value)}/>
                            )}
                        </FormItem>
                    </Col>
                    {pDieMobile > 0 ? (
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="假死手机处理过程">
                                {getFieldDecorator('pDieMobileText', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入假死手机处理过程',
                                        },
                                    ],
                                })(
                                    <TextArea rows={4} placeholder="输入假死手机处理过程" style={{ width: '100%' }} />,
                                )}
                            </FormItem>
                        </Col>
                    ) : ''}


                    <Col span={24}>
                        <FormItem {...formItemLayout} label="黑屏手机数量">
                            {getFieldDecorator('blackScreen', {
                                initialValue: 0,
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入黑屏手机数量',
                                    },
                                ],
                            })(<InputNumber onChange={(value) => this.props.changepBlackScreen(value)}/>)}
                        </FormItem>
                    </Col>

                    {blackScreen > 0 ? (
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="黑屏手机处理过程">
                                {getFieldDecorator('blackScreenText', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入黑屏手机处理过程',
                                        },
                                    ],
                                })(
                                    <TextArea rows={4} placeholder="输入黑屏手机处理过程" style={{ width: '100%' }} />,
                                )}
                            </FormItem>
                        </Col>
                    ) : ''}

                </Row>
            </Form>
        );
        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isUpdateShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    closable = {false}
                    cancelText="设备打标">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    uiStatus: state.machineCheck.uiStatus,
    pDieMobile:state.machineCheck.pDieMobile,
    batteryStatus:state.machineCheck.batteryStatus,
    blackScreen:state.machineCheck.blackScreen,
});
const mapDispatchToProps = dispatch => ({
    addCheckData: data => dispatch(addCheckData(data)),
    modalShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    addCommandDb: () =>  dispatch(addCommandDb()),
    changepDieMobile: (value) => dispatch(actions.changepDieMobile(value)),
    changepBatteryStatus: (value) => dispatch(actions.changepBatteryStatus(value)),
    changepBlackScreen: (value) => dispatch(actions.changepBlackScreen(value)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(MachineCheck));



// WEBPACK FOOTER //
// ./pages/client/machineCheck/index.js